import * as React from 'react';
import { Container, DropzoneInfoContainerFull, DropzoneInfoContainerLabelMini, DropzoneInfoContainerMini, FittedLoader, StyledDropzoneArea, StyledDropzoneFileRowContainer, } from './StylovyzeDropzone.styles';
import Dropzone from 'react-dropzone';
import { RejectedFile, UpArrowCircle } from './icons';
import { deleteFile, downloadFromS3, getSignedURLs, pollUploadStatus, uploadToS3, } from './StylovyzeDropzoneUtils';
import Loading from '@innovyze/stylovyze/lib/components/Loading';
import { StylovyzeDropzoneRowContainer } from './StylovyzeDropzoneRowContainer';
import UploadFilePaper from './icons/UploadFilePaper';
import { amUploadBaseURL } from '@innovyze/stylovyze/lib/apis/amUpload.api';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
import { useState } from 'react';
/**
 * StylovyzeDropzone
 */
export const StylovyzeDropzone = (props) => {
    const { t } = useGlobalization();
    const { downloadApiUrl, deleteApiUrl, token } = props;
    const initialAttachedFiles = props.files || [];
    const [uploadedFiles, setUploadedFiles] = useState(initialAttachedFiles);
    const [rejectedFileNames, setRejectedFileNames] = useState([]);
    const [uploading, setUploading] = useState(false);
    let handleDownloadClick = undefined;
    if (downloadApiUrl)
        handleDownloadClick = (af) => async () => {
            const { path, dateCreated } = af;
            const fileProperties = {
                ...af?.props,
                ...props.downloadParams,
            };
            const downloadLink = await downloadFromS3(downloadApiUrl ?? '', {
                path,
                dateCreated,
                ...fileProperties,
            }, token);
            if (downloadLink?.location) {
                const href = document.createElement('a');
                href.setAttribute('href', downloadLink.location);
                href.setAttribute('download', 'download');
                href.click();
                href.remove();
            }
        };
    let handleDeleteClick = undefined;
    if (deleteApiUrl)
        handleDeleteClick =
            (af, index) => async () => {
                const { path, dateCreated } = af;
                const fileProperties = {
                    ...af?.props,
                    ...props.deleteParams,
                };
                await deleteFile(deleteApiUrl, {
                    path,
                    dateCreated,
                    ...fileProperties,
                }, token);
                const newFiles = uploadedFiles;
                newFiles.splice(index, 1);
                setUploadedFiles([...newFiles]);
                if (props.onFileDelete)
                    props.onFileDelete(af);
            };
    const onDropAccepted = async (acceptedFiles, evt) => {
        props.onFileSelect?.();
        setUploading(true);
        setRejectedFileNames([]);
        const signedUrls = await getSignedURLs(amUploadBaseURL + '/v2/upload', acceptedFiles, props.uploadParams || {}, props.token);
        const uploadIds = signedUrls.map(e => e.uploadId);
        await uploadToS3(acceptedFiles, signedUrls);
        await pollUploadStatus(uploadIds, amUploadBaseURL + '/v2/upload/status', props.token, setUploading, [...uploadedFiles], [], setUploadedFiles, [], setRejectedFileNames, props.onDropAccept);
    };
    const getDragClassName = (isDragActive, isDragAccept, isDragReject) => {
        const classNames = [];
        if (isDragAccept)
            classNames.push('drag-accept');
        if (isDragActive)
            classNames.push('drag-active');
        if (isDragReject)
            classNames.push('drag-reject');
        return classNames.join(' ');
    };
    const getDZBody = (isDragActive, isDragAccept, isDragReject) => {
        let iconFill = '#C9D6DC';
        if (isDragReject || rejectedFileNames.length > 0) {
            iconFill = '#AA0000';
        }
        let text = props?.mainFileText ||
            t('Drag and drop files here', { context: 'File dropzone' });
        if (rejectedFileNames.length > 0) {
            const rejectedFilesString = rejectedFileNames.join(', ');
            text = t('File(s) "{{rejectedFilesString}}" could not be uploaded due to detected malware', { rejectedFilesString, context: 'File dropzone' });
        }
        else if (isDragReject) {
            text = t(
            // eslint-disable-next-line quotes
            "The files you're trying to import are in an invalid format", { context: 'File dropzone' });
        }
        const maxSize = (props?.dropzoneOptions?.maxSize || 0) / (1024 * 1024);
        if (uploadedFiles.length) {
            return (React.createElement(DropzoneInfoContainerMini, { className: getDragClassName(isDragActive, isDragAccept, isDragReject) },
                React.createElement(DropzoneInfoContainerLabelMini, null,
                    React.createElement(UploadFilePaper, { fill: iconFill }),
                    React.createElement("div", null, text))));
        }
        else {
            let icon = React.createElement(UpArrowCircle, { fill: iconFill });
            if (rejectedFileNames.length > 0) {
                icon = React.createElement(RejectedFile, null);
            }
            return (React.createElement(DropzoneInfoContainerFull, { className: getDragClassName(isDragActive, isDragAccept, isDragReject) },
                React.createElement(StyledDropzoneFileRowContainer, null,
                    icon,
                    React.createElement("h3", null, text),
                    React.createElement("p", null, props?.supportedFileText ||
                        t('Supported file types include: .doc, .xls, .png, .mp3, .mp4', { context: 'File dropzone' })),
                    props?.dropzoneOptions?.maxSize ? (React.createElement("p", null, t('Max size {{maxSize}} MB', {
                        maxSize,
                        context: 'File dropzone',
                    }))) : null)));
        }
    };
    return (React.createElement(Container, null,
        React.createElement(StylovyzeDropzoneRowContainer, { files: uploadedFiles, onDownloadClick: handleDownloadClick, onDeleteClick: handleDeleteClick }),
        props.noUpload ? null : (React.createElement(Dropzone, { ...props, accept: props?.dropzoneOptions?.accept, multiple: !props.single, onDropAccepted: onDropAccepted }, ({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, }) => (React.createElement(FittedLoader, null,
            React.createElement(Loading, { loading: uploading },
                React.createElement(StyledDropzoneArea, { ...getRootProps({
                        className: 'dropzone',
                    }) },
                    React.createElement("input", { ...getInputProps() }),
                    getDZBody(isDragActive, isDragAccept, isDragReject)))))))));
};
StylovyzeDropzone.defaultProps = {};
export default StylovyzeDropzone;
